module.exports = __webpack_public_path__ + "static/media/Inter-Regular.41cd7069.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Regular.woff
// module id = 701
// module chunks = 21